import React from "react";
import {Map, InfoWindow, Marker, GoogleApiWrapper} from 'google-maps-react';
import { connect } from "react-redux";

// Get value for style
let windowWidth = window.innerWidth;
let value = windowWidth <= 760 ? '8%' : '0%';

export class GoogleMap extends React.Component {
  render() {
    return (
      <div className="container" style={{ marginBottom: "3%" }}>
        <div className="row" style={{ marginTop:"5%" }}>
          <div className="col-md-8" style={{ height:500, marginRight:value }}>
            <Map 
              google={this.props.google} 
              style={{ width: '100%', height: '100%', position: 'relative', margin: "1% auto", 
                background:`linear-gradient(${this.props.templates.templates.templateProperties.background_map_first}, ${this.props.templates.templates.templateProperties.background_map_second})` 
              }}
              zoom={15}
              fullscreenControl={false}
              initialCenter={{
                lat: 10.789619, 
                lng: 106.639644
              }}
              >
                <Marker onClick={this.onMarkerClick}
                        name={'Current location'} />
                <InfoWindow onClose={this.onInfoWindowClose}>
                </InfoWindow>
            </Map>      
          </div>
          <div className="col-md-4">
            <div style={{ background:`linear-gradient(${this.props.templates.templates.templateProperties.background_store_address_first}, ${this.props.templates.templates.templateProperties.background_store_address_second})`, height:500, padding:50, color:`${this.props.templates.templates.templateProperties.color_store_address}`, fontSize:20, marginTop:"2%" }}>
                <h4 style={{ fontSize:25 }}>ĐỊA CHỈ CỬA HÀNG</h4>                
                <hr style={{ backgroundColor: `${this.props.templates.templates.templateProperties.color_store_address}` }} />    
                <p>{this.props.templates.templates.templateProperties.store_address}</p>       
                <p>{this.props.templates.templates.templateProperties.store_address_detail}</p>
            </div>
          </div>
        </div>    
      </div>          
    );
  }
}

// export default GoogleApiWrapper({
//   apiKey: ("AIzaSyA_oSxfWVTYnpVSms50c6uEZTzh5_pdZG4")
// })(GoogleMap)

const mapStateToProps = (state) => {
  return {
      templates: state.templates,
  };
};

export default connect(mapStateToProps)(GoogleApiWrapper({
  apiKey: ("AIzaSyA_oSxfWVTYnpVSms50c6uEZTzh5_pdZG4")
})(GoogleMap));